export const COLUMN_TITLE_HEIGHT = 24
export const COLUMN_PADDING = 20

export const AXIS_TOP_HEIGHT = 24
export const AXIS_BOTTOM_HEIGHT = 24
export const X_UNIT_PADDING = 30
export const AXIS_BOTTOM_CUTOFF_HEIGHT = 40
export const AXIS_BOTTOM_XUNIT_HEIGHT = 12

export const PADDING_TOP = 24
export const PADDING_SIDES = 20

export const Y_CONNECTOR = 7
export const Y_CONNECTOR_PADDING = 4
export const Y_LABEL_HEIGHT = 14
export const Y_END_LABEL_SPACE = 3 // width of space between label and value
export const X_TICK_HEIGHT = 4
export const Y_GROUP_MARGIN = 20
